import { render, staticRenderFns } from "./ModalManage.vue?vue&type=template&id=dcf8927e&scoped=true"
import script from "./ModalManage.vue?vue&type=script&lang=js"
export * from "./ModalManage.vue?vue&type=script&lang=js"
import style0 from "./ModalManage.vue?vue&type=style&index=0&id=dcf8927e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf8927e",
  null
  
)

export default component.exports